const File = {
  id: true,
  objectId: true,
  objectType: true,
  objectProperty: true,
  filename: true,
  mimetype: true,
  encoding: true,
  file: {
    url: true,
    path: true
  }
};

export {
	File
}